var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "article-wrapper" }, [
    _vm.entry
      ? _c(
          "div",
          [
            _c("header", { staticClass: "page" }, [
              _c("h2", {
                staticClass: "title-header",
                domProps: { innerHTML: _vm._s(_vm.entry.title) }
              })
            ]),
            _vm.entry.date
              ? _c("h4", [_vm._v(_vm._s(_vm.entry.date))])
              : _vm._e(),
            _vm.entry
              ? _c(
                  "main",
                  { staticClass: "article-content" },
                  [
                    _vm.entry.image
                      ? _c("article", { staticClass: "article-image" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.entry.image,
                              alt: _vm.entry.title
                            }
                          })
                        ])
                      : _vm._e(),
                    _c(
                      "article",
                      { staticClass: "article-text typography-text" },
                      [
                        _c(
                          "div",
                          { staticClass: "article-text__inner" },
                          [_vm._t("default")],
                          2
                        )
                      ]
                    ),
                    _c("no-ssr", [
                      _c(
                        "article",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.entrySlides.length > 0,
                              expression: "entrySlides.length > 0"
                            }
                          ],
                          staticClass: "article-slider"
                        },
                        [
                          _c(
                            "slider",
                            { ref: "slider", attrs: { autoplay: true } },
                            _vm._l(_vm.entrySlides, function(slide) {
                              return _c("image-slide", {
                                key: slide.id,
                                attrs: { image: slide.image }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm.entry.video_link
                      ? _c("content-video", {
                          attrs: { video: _vm.entry.video_link }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c("no-ssr", [
              _vm.backUrl
                ? _c(
                    "footer",
                    { staticClass: "more text-center" },
                    [
                      _c(
                        "link-to",
                        {
                          staticClass: "btn medium solid--green",
                          attrs: { to: _vm.backUrl }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.backTitle))])]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ],
          1
        )
      : _c("main", { staticClass: "article-content" }, [
          _c("article", { staticClass: "article-text typography-text" }, [
            _c(
              "div",
              { staticClass: "article-text__inner" },
              [_vm._t("default")],
              2
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b0bbc24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0bbc24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/articles/ArticlePage.vue
// module id = KVCO
// module chunks = 0 1 2 3 4 6 8 9 10